import SbButton from '@Components/Button';
// import { RootStateType } from '@Store';
import { Grid } from '@mui/material';
import React from 'react';
// import { useSelector } from 'react-redux';
// import { SHIPMENT_STATUS } from '@Constants/Shipment';

interface Props {
  onCancel?: () => void;
  onSave?: () => void;
  disabled?: boolean;
  saveButtonName?: string;
}

export default function Actions(props: Props) {
  const isDisabled = props.disabled ?? false;
  return (
    <Grid container justifyContent={'end'} sx={{ gap: 1.5, mt: 2 }}>
      {props.onCancel && (
        <SbButton
          variant="outlined"
          sx={{ height: 36, px: 2.5, borderRadius: '8px', fontWeight: 600 }}
          onClick={props.onCancel}
        >
          Cancel
        </SbButton>
      )}
      <SbButton
        variant="contained"
        sx={{ height: 36, px: 3, borderRadius: '8px', fontWeight: 600 }}
        onClick={props.onSave}
        disabled={isDisabled}
      >
        {props.saveButtonName ? props.saveButtonName : 'Save'}
      </SbButton>
    </Grid>
  );
}
